import styled from "@emotion/styled";
import type { CurrentViewport } from "@stepfinance/react";
import { useViewportWidth } from "@stepfinance/react";
import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/step.svg";

const StyledLogo = styled.div<{ viewport?: CurrentViewport }>`
  margin-bottom: ${({ viewport }) => (viewport === "Desktop" ? "10px" : "0")};
`;

const Logo: React.FC<{ viewport?: CurrentViewport }> = ({ viewport }) => {
  const logoSize: {
    [viewport in CurrentViewport]: string;
  } = {
    Mobile: logo,
    Desktop: logo,
  };
  return (
    <StyledLogo viewport={viewport}>
      <Link to="/">
        <img width={viewport === "Desktop" ? 111 : 92} src={logoSize[viewport ?? "Desktop"]} alt="Step logo" />
      </Link>
    </StyledLogo>
  );
};

export const HeaderLogoComponent: React.FC = () => {
  const { currentViewport } = useViewportWidth();
  return <Logo viewport={currentViewport} />;
};
